import axios from 'axios';
let bits = [];

export function pushSmartBit(bit) {
  const found = bits.find(it => it.id === bit.id);
  if (found.length > 0) {
    found[0].parentId = bit.parentId;
    found[0].content = bit.content;
    found[0].type = bit.type;
    return;
  }
  bits.push(bit);
}

export function smartSave() {
  debugger;
  axios.put("/designs/html/smart", bits);
  bits = [];
}
